export default "__VITE_ASSET__CFSAeXHH__"